import MainLayout from "@/components/layout/MainLayout";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import BenefitsSection from "./components/BenefitsSection";
import AboutSection from "./components/AboutSection";
import PromotionSection from "./components/PromotionSection";
import CtaSection from "./components/CtaSection";

export default function Home() {
  return (
    <MainLayout>
      <HeroSection />
      <ServicesSection />
      <BenefitsSection />
      <AboutSection />
      <PromotionSection />
      <CtaSection />
    </MainLayout>
  );
}